/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type FindRegistrationActivityQueryVariables = Types.Exact<{
  eventId: Types.Scalars["Int"];
}>;

export type FindRegistrationActivityQuery = {
  findManyEventActivity: Array<Pick<Types.EventActivity, "id">>;
};

export const FindRegistrationActivityDocument = gql`
  query FindRegistrationActivity($eventId: Int!) {
    findManyEventActivity(
      where: {
        event_id: { equals: $eventId }
        slug: { equals: "hacker-registration" }
      }
      take: 2
    ) {
      id
    }
  }
`;

/**
 * __useFindRegistrationActivityQuery__
 *
 * To run a query within a React component, call `useFindRegistrationActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRegistrationActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRegistrationActivityQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFindRegistrationActivityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FindRegistrationActivityQuery,
    FindRegistrationActivityQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    FindRegistrationActivityQuery,
    FindRegistrationActivityQueryVariables
  >(FindRegistrationActivityDocument, baseOptions);
}
export function useFindRegistrationActivityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FindRegistrationActivityQuery,
    FindRegistrationActivityQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    FindRegistrationActivityQuery,
    FindRegistrationActivityQueryVariables
  >(FindRegistrationActivityDocument, baseOptions);
}
export type FindRegistrationActivityQueryHookResult = ReturnType<
  typeof useFindRegistrationActivityQuery
>;
export type FindRegistrationActivityLazyQueryHookResult = ReturnType<
  typeof useFindRegistrationActivityLazyQuery
>;
export type FindRegistrationActivityQueryResult = ApolloReactCommon.QueryResult<
  FindRegistrationActivityQuery,
  FindRegistrationActivityQueryVariables
>;
